﻿{
  "US": "Yhdysvallat",
  "AF": "Afganistan",
  "AX": "Ahvenanmaa",
  "AL": "Albania",
  "DZ": "Algeria",
  "AS": "Amerikan Samoa",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antarktika",
  "AG": "Antigua ja Barbuda",
  "AR": "Argentiina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Itävalta",
  "AZ": "Azerbaidžan",
  "BS": "Bahama",
  "BH": "Bahrain",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BY": "Valkovenäjä",
  "BE": "Belgia",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BO": "Bolivia",
  "BA": "Bosnia ja Hertsegovina",
  "BW": "Botswana",
  "BV": "Bouvet’nsaari",
  "BR": "Brasilia",
  "IO": "Brittiläinen Intian valtameren alue",
  "BN": "Brunei Darussalam",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Kambodzha",
  "CM": "Kamerun",
  "CA": "Kanada",
  "CV": "Kap Verde",
  "KY": "Cayman saaret",
  "CF": "Keski-Afrikan tasavalta",
  "TD": "Tšad",
  "CL": "Chile",
  "CN": "Kiina",
  "CX": "Joulusaari",
  "CC": "Kookossaaret (Keelingsaaret)",
  "CO": "Kolumbia",
  "KM": "Komorit",
  "CG": "Kongo",
  "CD": "Kongon Demokraattinen Tasavalta",
  "CK": "Cookinsaaret",
  "CR": "Costa Rica",
  "CI": "Norsunluurannikko",
  "HR": "Kroatia",
  "CU": "Kuuba",
  "CY": "Kypros",
  "CZ": "Tsekin tasavalta",
  "DK": "Tanska",
  "DJ": "Djibouti",
  "DM": "Dominica",
  "DO": "Dominikaaninen tasavalta",
  "EC": "Ecuador",
  "EG": "Egypti",
  "SV": "El Salvador",
  "GQ": "Päiväntasaajan Guinea",
  "ER": "Eritrea",
  "EE": "Viro",
  "ET": "Etiopia",
  "FK": "Falklandinsaaret (Malvina)",
  "FO": "Färsaaret",
  "FJ": "Fidzi",
  "FI": "Suomi",
  "FR": "Ranska",
  "GF": "Ranskan Guayana",
  "PF": "Ranskan Polynesia",
  "TF": "Ranskan eteläiset alueet",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "DE": "Saksa",
  "GH": "Ghana",
  "GI": "Gibraltar",
  "GR": "Kreikka",
  "GL": "Grönlanti",
  "GD": "Grenada",
  "GP": "Guadeloupe",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "HT": "Haiti",
  "HM": "Heard saari ja McDonald saaret",
  "VA": "Pyhä istuin (Vatikaanivaltio)",
  "HN": "Honduras",
  "HK": "Hong Kong",
  "HU": "Unkari",
  "IS": "Islanti",
  "IN": "Intia",
  "ID": "Indonesia",
  "IR": "Iranin Islamilainen Tasavalta",
  "IQ": "Irak",
  "IE": "Irlanti",
  "IM": "Mansaari",
  "IL": "Israel",
  "IT": "Italia",
  "JM": "Jamaika",
  "JP": "Japani",
  "JE": "Jersey",
  "JO": "Jordania",
  "KZ": "Kazakstan",
  "KE": "Kenia",
  "KI": "Kiribati",
  "KR": "Korea",
  "KW": "Kuwait",
  "KG": "Kirgisia",
  "LA": "Laon Kansantasavalta",
  "LV": "Latvia",
  "LB": "Libanon",
  "LS": "Lesotho",
  "LR": "Liberia",
  "LY": "Libya",
  "LI": "Liechtenstein",
  "LT": "Liettua",
  "LU": "Luxemburg",
  "MO": "Macao",
  "MK": "Makedonia",
  "MG": "Madagaskar",
  "MW": "Malawi",
  "MY": "Malesia",
  "MV": "Malediivit",
  "ML": "Mali",
  "MT": "Malta",
  "MH": "Marshallinsaaret",
  "MQ": "Martinique",
  "MR": "Mauritania",
  "MU": "Mauritius",
  "YT": "Mayotte",
  "MX": "Meksiko",
  "FM": "Micronesian Liittovaltio",
  "MD": "Moldova",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MA": "Marokko",
  "MZ": "Mosambik",
  "MM": "Myanmar",
  "NA": "Namibia",
  "NR": "Nauru",
  "NP": "Nepali",
  "NL": "Alankomaat",
  "AN": "Alankomaiden Antillit",
  "NC": "Uusi-Kaledonia",
  "NZ": "Uusi Seelanti",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NF": "Norfolk Island",
  "MP": "Pohjoiset Mariana saaret",
  "NO": "Norja",
  "OM": "Oman",
  "PK": "Pakistan",
  "PW": "Palau",
  "PS": "Palestiinan alue, miehitetty",
  "PA": "Panama",
  "PG": "Papua-Uusi-Guinea",
  "PY": "Paraguay",
  "PE": "Peru",
  "PH": "Filippiinit",
  "PN": "Pitcairn",
  "PL": "Puola",
  "PT": "Portugali",
  "PR": "Puerto Rico",
  "QA": "Qatar",
  "RE": "Reunion",
  "RO": "Romania",
  "RU": "Venäjän liittovaltio",
  "RW": "Ruanda",
  "BL": "Saint-Barthelemy",
  "SH": "Saint Helena",
  "KN": "Saint Kitts ja Nevis",
  "LC": "Saint Lucia",
  "MF": "Saint Martin",
  "PM": "Saint Pierre ja Miquelon",
  "VC": "Saint Vincent ja Grenadines",
  "WS": "Samoa",
  "SM": "San Marino",
  "ST": "São Tomé ja Príncipe",
  "SA": "Saudi Arabia",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychellit",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SK": "Slovakia",
  "SI": "Slovenia",
  "SB": "Salomonsaaret",
  "SO": "Somalia",
  "ZA": "Etelä-Afrikka",
  "GS": "Etelä-Georgia ja Sandwich saaret",
  "ES": "Espanja",
  "LK": "Sri lanka",
  "SD": "Sudan",
  "SR": "Suriname",
  "SJ": "Svalbard ja Jan Mayen",
  "SZ": "Swazimaa",
  "SE": "Sweden",
  "CH": "Sveitsi",
  "SY": "Syyrian arabitasavalta",
  "TW": "Taiwan",
  "TJ": "Tadzhikistan",
  "TZ": "Tansania",
  "TH": "Thaimaa",
  "TL": "Timor-Leste",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad ja Tobago",
  "TN": "Tunisia",
  "TR": "Turkki",
  "TM": "Turkmenistan",
  "TC": "Turks- ja Caicossaaret",
  "TV": "Tuvalu",
  "UG": "Uganda",
  "UA": "Ukraina",
  "AE": "Yhdistyneet arabiemiirikunnat",
  "GB": "Iso-Britannia",
  "UM": "Yhdysvaltain saarialueet",
  "UY": "Uruguay",
  "UZ": "Uzbekistan",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "VG": "Brittiläiset Neitsytsaaret",
  "VI": "Yhdysvaltain Neitsytsaaret",
  "WF": "Wallis ja Futuna",
  "EH": "Länsi-Sahara",
  "YE": "Jemen",
  "ZM": "Sambia",
  "ZW": "Zimbabwe"
}
